var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-suggest" }, [
    _c("div", { staticClass: "o-wrapper" }, [
      _c("h1", [_vm._v("Suggest a Community")]),
      _vm._v(" "),
      _vm.posted === false
        ? _c("div", [
            _c("p", [
              _vm._v(
                "At " +
                  _vm._s(_vm.$root.brand.name) +
                  ", we are constantly adding new and exciting communities to the platform.  Should you believe there is a community that is not yet on " +
                  _vm._s(_vm.$root.brand.name) +
                  " that should be, please let us know by filling in the form below."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Please keep in mind that " +
                  _vm._s(_vm.$root.brand.name) +
                  " communities must have a strong social following, especially across social networks.  The stronger this following, the more likely a community will be added to " +
                  _vm._s(_vm.$root.brand.name) +
                  "."
              ),
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "suggestForm",
                staticClass: "u-m-t4",
                attrs: { method: "post" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmit.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "c-suggest__input-group" }, [
                  _c("label", { attrs: { for: "community-name" } }, [
                    _vm._v("Name of Community"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.suggestion.communityName,
                        expression: "suggestion.communityName",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "communityName",
                    staticClass: "c-textbox u-width-full",
                    attrs: { id: "community-name", type: "text" },
                    domProps: { value: _vm.suggestion.communityName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.suggestion,
                          "communityName",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-suggest__input-group" }, [
                  _c("label", { attrs: { for: "url-w" } }, [
                    _vm._v("Website URL"),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "icon w" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.suggestion.websiteUrl,
                        expression: "suggestion.websiteUrl",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "websiteUrl",
                    staticClass: "c-textbox",
                    attrs: {
                      id: "url-w",
                      type: "text",
                      placeholder: "https://",
                    },
                    domProps: { value: _vm.suggestion.websiteUrl },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.suggestion,
                          "websiteUrl",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-suggest__input-group" }, [
                  _c("label", { attrs: { for: "url-f" } }, [
                    _vm._v("Facebook URL"),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "icon f" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.suggestion.facebookUrl,
                        expression: "suggestion.facebookUrl",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "facebookUrl",
                    staticClass: "c-textbox",
                    attrs: {
                      id: "url-f",
                      type: "text",
                      placeholder: "https://",
                    },
                    domProps: { value: _vm.suggestion.facebookUrl },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.suggestion,
                          "facebookUrl",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-suggest__input-group" }, [
                  _c("label", { attrs: { for: "url-t" } }, [
                    _vm._v("Twitter URL"),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "icon t" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.suggestion.twitterUrl,
                        expression: "suggestion.twitterUrl",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "twitterUrl",
                    staticClass: "c-textbox",
                    attrs: {
                      id: "url-t",
                      type: "text",
                      placeholder: "https://",
                    },
                    domProps: { value: _vm.suggestion.twitterUrl },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.suggestion,
                          "twitterUrl",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-suggest__input-group" }, [
                  _c("label", { attrs: { for: "url-i" } }, [
                    _vm._v("Instagram URL"),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "icon i" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.suggestion.instagramUrl,
                        expression: "suggestion.instagramUrl",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "instagramUrl",
                    staticClass: "c-textbox",
                    attrs: {
                      id: "url-i",
                      type: "text",
                      placeholder: "https://",
                    },
                    domProps: { value: _vm.suggestion.instagramUrl },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.suggestion,
                          "instagramUrl",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-suggest__input-group" }, [
                  _c("label", { attrs: { for: "url-y" } }, [
                    _vm._v("YouTube URL"),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "icon y" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.suggestion.youtubeUrl,
                        expression: "suggestion.youtubeUrl",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "youtubeUrl",
                    staticClass: "c-textbox",
                    attrs: {
                      id: "url-y",
                      type: "text",
                      placeholder: "https://",
                    },
                    domProps: { value: _vm.suggestion.youtubeUrl },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.suggestion,
                          "youtubeUrl",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-suggest__input-group" }, [
                  _c("label", { attrs: { for: "comments" } }, [
                    _vm._v("Additional Comments"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.suggestion.comments,
                        expression: "suggestion.comments",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "comments",
                    staticClass: "c-textbox u-width-full",
                    attrs: { id: "comments", type: "text" },
                    domProps: { value: _vm.suggestion.comments },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.suggestion,
                          "comments",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
          ])
        : _c("div", [
            _c("p", [
              _vm._v(
                "Thank you for your community suggestion - our team will review your submission and confirm whether it meets the specific criteria required to become a " +
                  _vm._s(_vm.$root.brand.name) +
                  " community."
              ),
            ]),
            _vm._v(" "),
            _vm.previous.href
              ? _c("a", {
                  staticClass: "c-btn u-text-small u-p-x3 u-p-y1",
                  attrs: { href: _vm.previous.href },
                  domProps: { innerHTML: _vm._s(_vm.previous.text) },
                })
              : _vm._e(),
          ]),
      _vm._v(" "),
      _c("div", { ref: "message", class: ["c-fixed-message", "error"] }, [
        _c("p", [_vm._v("Errors occurred!")]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "c-suggest__input-group u-width-half u-width-full@l u-width-10/12@m u-width-full@s",
      },
      [
        _c("div", { staticClass: "c-suggest__actions" }, [
          _c("input", {
            staticClass: "c-btn u-text-small u-p-x3 u-p-y1",
            attrs: { type: "submit", value: "Submit for Review" },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }